<template>
  <div class="wrap">
    <div class="searchNavBar flex flex_start">
      <div class="title">我惠云店</div>
      <van-search placeholder="请输入搜索关键词" shape="round" :background="m_color" style="width: 100%" @click="$router.push('/common/search?active=0')">
      </van-search>
    </div>
    <!--分类栏：精选+分类-->
    <div class="tabBox">
    <van-tabs :active="tabIndex" :swipe-threshold="5" :background="m_color" color="#ffffff"
              title-active-color="#ffffff" title-inactive-color="#ffffff" :border="false" :ellipsis="false"
              @click="changeTab">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name" :offset-top="50">
      </van-tab>
    </van-tabs>
    </div>
    <!--占绝对定位的高度-->
    <div style="height: 100px;"></div>
    <!--精选+分类栏对应的每个页面-->
    <van-swipe :initial-swipe="tabIndex" :show-indicators="false" :touchable="true" @change="changeSwiper">
      <van-swipe-item class="swiper-item" v-for="(item, index) in tabs" :key="index">
        <div class="scroll-v list" v-if="tabIndex===index">
          <fine v-if="index===0" @initData="getCateList"></fine>
          <cate v-if="index>0" :cateId="item.id" :uptab="item"></cate>
        </div>
      </van-swipe-item>
    </van-swipe>
    <!--底部菜单-->
    <foot-bar :active="1"></foot-bar>
  </div>
</template>
<script>
import fine from './fine.vue'
import cate from './cate.vue'
export default {
  name: 'index',
  components: {
    fine,
    cate
  },
  data() {
    return {
      color: this.m_color,
      tabs: [{
        name: '精选',
        value: '1'
      }],
      tabIndex: 0
    }
  },
  methods: {
    //从子组件中传过来分类信息
    getCateList(data) {
      this.tabs.splice(1, this.tabs.length - 1); //保留第一个精选，删除后面的
      this.tabs = this.tabs.concat(data);
    },
    changeTab(index) {
      this.tabIndex = index
    },
    changeSwiper(index) {
      this.tabIndex = index
    }
  }
}
</script>

▫<style scoped lang="less">
.wrap {
  height: 100vh;
}

/*控制首页的tabs的背景色，不可删除*/
/deep/ .van-tabs__scroll {
  background-color: #E61B1B !important;
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/whyd/index.vue